var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"background",staticStyle:{"height":"100vh"},attrs:{"justify":"center","align":"center"}},[_c('v-col',{attrs:{"cols":"12","sm":"6","md":"4","lg":"3"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }